import { styled } from '@mui/material'
import { FC, memo } from 'react'
import { Flex } from '../../../styles'
import { Charting } from '../../Charting'

const Wrap = styled(Flex)`
  width: 100vw;
  min-height: 300px;
  display: flex;
  flex-direction: column;
`

export const MobileCharting: FC = memo(() => {
  return (
    <Wrap>
      <Charting></Charting>
    </Wrap>
  )
})
